export const analyticsGA4Event = (event, eventProperties = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...eventProperties })
  }
}

export default function useAnalyticsEvent() {
  return {
    analyticsGA4Event
  }
}
